// Fallback chapter list used while the /chapters collection is loading or
// unavailable. Keeps the standalone forms functional if Firestore is down.
export const FALLBACK_CHAPTERS = [
  { slug: "wny",            name: "Western New York" },
  { slug: "denver",         name: "Denver" },
  { slug: "upstate",        name: "Central New York" },
  { slug: "capital-region", name: "Capital Region" },
  { slug: "hudson-valley",  name: "Hudson Valley" },
];

// Quick lookup used to pre-populate a chapter select from a ?chapter=slug query param.
export const FALLBACK_CHAPTER_SLUG_TO_NAME = Object.fromEntries(
  FALLBACK_CHAPTERS.map(c => [c.slug, c.name])
);
